// axios config
axios.defaults.baseURL = KZ_CONFIG.WX_API_URL;
//axios.defaults.baseURL='http://test-shopapi.kuaizaixuetang.com';
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  if (config.url.indexOf('https://sp.kuaizaixuetang.com/') < 0) {
    config.headers.common = KZ.GetHeaders();
  }
	KZ.closeWarnMsg();
	if (config.url != 'lms-service/order_service/check-order-status') {
		//如果不是未支付订单 循环发起请求判断订单状态是否已经发送改变的 请求，需要打开loading效果
		MINT.Indicator.open();
	}
	return config;
}, function (error) {
	// 对请求错误做些什么
	// console.error('before send error');

	return Promise.reject(error).catch(err => {
		console.error(err);
	});
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	// 对响应数据做点什么
	$('.mint-indicator').hide()
	MINT.Indicator.close();
	return response;
}, function (error) {
	// 对响应错误做点什么
	if(error.response && error.response.status == 403){
		localStorage.removeItem('user_info');
		var server = window.location.href;
		sessionStorage.setItem('server-url',server);
		window.location.href = '/login';
	}else{
		KZ.toggleWarnMsgHttpStatus(error);
	}

	MINT.Indicator.close();
	return Promise.reject(error).catch(err => {
		console.error(err);
	});
});



// WEBPACK FOOTER //
// ./src/assets/js/axios.conf.js